import Tooltip from './component.jsx'
export default Tooltip
export { TooltipContentWrapper } from './component.styles'
